// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--smDL2","delimiter":"delimiter--SKzRQ","label":"label--MaflG","title":"title--SEq7D","description":"description--vkTYG","files":"files--NfD7x","hint":"hint--crlpr"};